export const Type = {
    SET_INITIAL_STATE: 'SET_INITIAL_STATE_MACHINES',
    GET_MACHINES_GROUP_CALL: 'GET_MACHINES_GROUP_CALL',
    GET_MACHINES_GROUP_SUCCESS: 'GET_MACHINES_GROUP_SUCCESS',
    GET_MACHINES_GROUP_FAILED: 'GET_MACHINES_GROUP_FAILED',
    GET_MACHINES_SUBGROUP_CALL: 'GET_MACHINES_SUBGROUP_CALL',
    GET_MACHINES_SUBGROUP_SUCCESS: 'GET_MACHINES_SUBGROUP_SUCCESS',
    GET_MACHINES_SUBGROUP_FAILED: 'GET_MACHINES_SUBGROUP_FAILED',
    GET_MACHINES_DROPDOWN_CALL: 'GET_MACHINES_DROPDOWN_CALL',
    GET_MACHINES_DROPDOWN_SUCCESS: 'GET_MACHINES_DROPDOWN_SUCCESS',
    GET_MACHINES_DROPDOWN_FAILED: 'GET_MACHINES_DROPDOWN_FAILED',
    ADD_MACHINE_CALL: 'ADD_MACHINE_CALL',
    ADD_MACHINE_SUCCESS: 'ADD_MACHINE_SUCCESS',
    ADD_MACHINE_FAILED: 'ADD_MACHINE_FAILED',
    GET_MACHINE_CALL: 'GET_MACHINE_CALL',
    GET_MACHINE_SUCCESS: 'GET_MACHINE_SUCCESS',
    GET_MACHINE_FAILED: 'GET_MACHINE_FAILED',
    GET_MACHINES_VIEW_CALL: 'GET_MACHINES_VIEW_CALL',
    GET_MACHINES_VIEW_SUCCESS: 'GET_MACHINES_VIEW_SUCCESS',
    GET_MACHINES_VIEW_FAILED: 'GET_MACHINES_VIEW_FAILED',
    ADD_MACHINE_GROUP_CALL: 'ADD_MACHINE_GROUP_CALL',
    ADD_MACHINE_GROUP_SUCCESS: 'ADD_MACHINE_GROUP_SUCCESS',
    ADD_MACHINE_GROUP_FAILED: 'ADD_MACHINE_GROUP_FAILED',
    GET_MACHINE_SUBGROUP_CALL: 'GET_MACHINE_SUBGROUP_CALL',
    GET_MACHINE_SUBGROUP_SUCCESS: 'GET_MACHINE_SUBGROUP_SUCCESS',
    GET_MACHINE_SUBGROUP_FAILED: 'GET_MACHINE_SUBGROUP_FAILED',
    ADD_MACHINE_SUBGROUP_CALL: 'ADD_MACHINE_SUBGROUP_CALL',
    ADD_MACHINE_SUBGROUP_SUCCESS: 'ADD_MACHINE_SUBGROUP_SUCCESS',
    ADD_MACHINE_SUBGROUP_FAILED: 'ADD_MACHINE_SUBGROUP_FAILED',
    SET_MACHINE_ROW_IN_REDUCER: 'SET_MACHINE_ROW_IN_REDUCER',
    DELETE_MACHINE_SUCCESS: 'DELETE_MACHINE_SUCCESS',
    DELETE_MACHINE_FAILED: 'DELETE_MACHINE_FAILED',
    ADD_MACHINE_FAVORITE_SUCCESS: 'ADD_MACHINE_FAVORITE_SUCCESS',
    DELETE_MACHINE_FAVORITE_SUCCESS: 'DELETE_MACHINE_FAVORITE_SUCCESS'
};

// Minimal action creators to keep connected components/reducers functional.
export const setInitialState = (data) => ({
    type: Type.SET_INITIAL_STATE,
    data
});

export const deleteMachine = (selection, name = 'machine') => (dispatch) => {
    dispatch({ type: Type.DELETE_MACHINE_SUCCESS, name, forDelete: selection || [] });
};
